<mat-form-field class="size-sm relative w-full" floatLabel="auto">
  @if (isLoading) {
    <div class="absolute left-[6px] top-1 flex h-8 w-full items-center justify-center">
      <mat-spinner diameter="16" />
    </div>
  }
  <mat-label [ngClass]="{ 'px-2': showSearch }">{{ label | translate }}</mat-label>
  <mat-select
    (selectionChange)="onSelectionChange($event)"
    [formControl]="multiple ? selectionControlMulti : selectionControl"
    [multiple]="multiple">
    @if (multiple) {
      <mat-select-trigger [ngClass]="{ 'pl-2': showSearch }">
        {{ selectionControlMulti.value?.[0]?.['label'] || '' }}
        @if ((selectionControlMulti.value?.length || 0) > 1) {
          <span>
            (+{{ (selectionControlMulti.value?.length || 0) - 1 }}
            {{
              (selectionControlMulti.value?.length === 2 ? 'global.filter.other' : 'global.filter.others') | translate
            }}
            )
          </span>
        }
      </mat-select-trigger>
    }

    @if (showSearch) {
      <mat-form-field appearance="outline" class="size-sm px/-2 w-full">
        <input
          matInput
          type="text"
          [attr.aria-label]="filterPlaceholder"
          [formControl]="filterControl"
          [placeholder]="filterPlaceholder | translate"
          (keydown)="keyDownHandler($event)" />
        <mat-icon matPrefix>search</mat-icon>
      </mat-form-field>
    }

    @for (option of filteredOptions$ | async; track $index) {
      <mat-option class="flex p-2" [value]="option">
        <div class="flex-1">{{ option.label }}</div>
        @if (option.sublabel) {
          <div class="text-sm text-[var(--neutral-50)] dark:text-[var(--neutral-70)]">{{ option.sublabel }}</div>
        }
      </mat-option>
    } @empty {
      @if (allowNew && filterControl.value) {
        <mat-option class="no-value" [value]="filterControl.value" (click)="setCustomOption(filterControl.value)">
          {{ 'global.filter.itemsNotFoundCustom' | translate }} "{{ filterControl.value }}"?
        </mat-option>
      } @else {
        <mat-option class="no-value pointer-events-none">{{ 'global.filter.itemsNotFound' | translate }} </mat-option>
      }
    }
  </mat-select>

  @if (showClearButton$ | async) {
    <mat-icon (click)="onClearInput($event)" matSuffix>cancel</mat-icon>
  }
</mat-form-field>
